import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; 
import Cookies from "js-cookie";
import axios from "axios";
import { useState, useEffect } from 'react';
import { FaSpinner } from "react-icons/fa6";
import { useDispatch } from 'react-redux';
import { setUserRole, setUserStep } from "../../Redux/userSlice.js";

export const getUserRole = () => {
  const token = Cookies.get("jwtToken");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token); 
    return decoded.role; 
  } catch (error) {
    console.error("Error decoding token", error);
    return null;
  }
};

export const getUserRoleAndStep = async () => {
  const token = Cookies.get("jwtToken");
  console.log("Token:", token);
  if (!token) return null;

  try {
    const decoded = jwtDecode(token); 
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/user`);
    const user = await response.data;

    const userData = { role: decoded.role, step: user.step };

    // Dispatch the user data to Redux
    // dispatch(setUserRole(userData.role));
    // dispatch(setUserStep(userData.step));

    return userData; // Return the user data as well

  } catch (error) {
    console.error("Error decoding token", error);
    return null;
  }
};


const PrivateRoute = ({ children, allowedRoles, path }) => {
  const navigate = useNavigate();

  const [isAuthorized, setIsAuthorized] = useState(null);
  const [isRedirect, setIsRedirect] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pathRedirect, setPathRedirect] = useState(null);

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        let userRole = getUserRole();

        // Check if the user is authorized based on their role
        if (allowedRoles && allowedRoles.length > 0) {
          if (!userRole || !allowedRoles.includes(userRole)) {
            if (allowedRoles.includes("free")) {
              setIsAuthorized(true);
            } else {
              setIsAuthorized(false);
            }
          } else {
            setIsAuthorized(true);
          }
        }

        // Handle specific path-based redirects
        if (path) {
          const userRoleAndStep = await getUserRoleAndStep();

          console.log({ userRoleAndStep, path });

          // If there is no token and you are at the login page, stay at /login
          if (!getUserRole() && path === '/login') {
            setIsAuthorized(true);
            setIsLoading(false);
            return;
          }

          // If there's a token and you're trying to access /login, redirect to home
          if (userRoleAndStep && path === '/login') {
            setIsRedirect(true);
          } else if (
            userRoleAndStep &&  
            userRoleAndStep.step >= 2 &&
            userRoleAndStep.role &&
            path === "/register"
          ) {
            setIsRedirect(true);
          } else if (
            userRoleAndStep &&
            userRoleAndStep.step >= 2 &&
            userRoleAndStep.role === "admin" &&
            path === "/onboarding/ngoform"
          ) {
            setIsRedirect(true);
          } else if (
            userRoleAndStep &&
            userRoleAndStep.step >= 2 &&
            userRoleAndStep.role === "individual" &&
            path === "/onboarding/userform"
          ) {
            setIsRedirect(true);
          } else if (!userRoleAndStep) {
            setPathRedirect(path);
          }
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Authorization check failed:", error);
        setIsLoading(false);
      }
    };

    checkAuthorization();
  }, [allowedRoles, path]);

  useEffect(() => {
    if (pathRedirect) {
      navigate(pathRedirect);
      setPathRedirect(null);
    }
  }, [pathRedirect, navigate]);

  if (isLoading) {
    return (
      <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-white-500 bg-opacity-50 z-50">
        <div className="text-white">
          <FaSpinner />
        </div>
      </div>
    );
  }

  console.log({ isAuthorized, isRedirect, pathRedirect });

  // If there's no token and we're not at the login page, redirect to /unauthorized
  if (!getUserRole() && path !== '/login') {
    return <Navigate to="/unauthorized" replace />;
  }

  // If the user is not authorized and trying to access a restricted page
  if (!isAuthorized && !isRedirect) {
    return <Navigate to="/unauthorized" replace />;
  }

  // If the user is logged in but tries to go to /login, redirect to home page
  if (isRedirect && pathRedirect === null) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
